export const UserDetailTabType = {
  Basic: 1,
  UsageSituation: 2,
  OtherContacts: 3,
  Family: 4,
  NewArrivalNotice: 5,
  OldName: 6,
  Lending: 7,
  Reserved: 8,
  MailHistory: 9,
  ExternalCollaboration: 10
}
export type UserDetailTabType = typeof UserDetailTabType[keyof typeof UserDetailTabType]

export const UserDetailPageState = {
  UserShow: 'userShow',
  UserUpdate: 'userUpdate',
  UserCreate: 'userCreate',
  GroupShow: 'groupShow',
  GroupUpdate: 'groupUpdate',
  GroupCreate: 'groupCreate'
}
export type UserDetailPageState = typeof UserDetailPageState[keyof typeof UserDetailPageState]

export interface UserDetailStateInfo {
  state: UserDetailPageState
  isUserShow: Function
  isGroupShow: Function
  isShow: Function
  isUserUpdate: Function
  isGroupUpdate: Function
  isUpdate: Function
  isUserCreate: Function
  isGroupCreate: Function
  isCreate: Function
  isCreateOrUpdate: Function
  isUserCreateOrUpdate: Function
  isGroupCreateOrUpdate: Function
  isUser: Function
  isGroup: Function
}

export const defaultUserDetailStateInfo = (): any => ({
  state: UserDetailPageState.UserShow,
  isUserShow() {
    return this.state === UserDetailPageState.UserShow
  },
  isGroupShow() {
    return this.state === UserDetailPageState.GroupShow
  },
  isShow() {
    return this.isUserShow() || this.isGroupShow()
  },
  isUserUpdate() {
    return this.state === UserDetailPageState.UserUpdate
  },
  isGroupUpdate() {
    return this.state === UserDetailPageState.GroupUpdate
  },
  isUpdate() {
    return this.isUserUpdate() || this.isGroupUpdate()
  },
  isUserCreate() {
    return this.state === UserDetailPageState.UserCreate
  },
  isGroupCreate() {
    return this.state === UserDetailPageState.GroupCreate
  },
  isCreate() {
    return this.isUserCreate() || this.isGroupCreate()
  },
  isCreateOrUpdate() {
    return this.isUpdate() || this.isCreate()
  },
  isUserCreateOrUpdate() {
    return (
      this.state === UserDetailPageState.UserUpdate ||
      this.state === UserDetailPageState.UserCreate
    )
  },
  isGroupCreateOrUpdate() {
    return (
      this.state === UserDetailPageState.GroupUpdate ||
      this.state === UserDetailPageState.GroupCreate
    )
  },
  isUser() {
    return (
      this.state === UserDetailPageState.UserShow ||
      this.state === UserDetailPageState.UserUpdate ||
      this.state === UserDetailPageState.UserCreate
    )
  },
  isGroup() {
    return (
      this.state === UserDetailPageState.GroupShow ||
      this.state === UserDetailPageState.GroupUpdate ||
      this.state === UserDetailPageState.GroupCreate
    )
  }
})

export const UserExternalCollaborationStatus = {
  Unused: '0',
  Issued: '1',
  IdInvalid: '2'
}
export type UserExternalCollaborationStatus = typeof UserExternalCollaborationStatus[keyof typeof UserExternalCollaborationStatus]
